import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import "datatables.net"
import "datatables.net-responsive"

export default class extends Controller {
  static targets = ["selectAll", "child", "table"]

  connect() {
    this.initializeDataTable()
  }

  initializeDataTable() {
    if (this.hasTableTarget) {
      $(this.tableTarget).DataTable({
        responsive: true,
        retrieve: true,
        autoWidth: false,
        processing: true,
        paging: true,
        pageLength: 100,
        order: [[2, "asc"]],
        language: {
          search: '<i class="fa fa-search"></i>',
          searchPlaceholder: "SEARCH",
        },
      })
    }
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.childTargets.forEach(child => {
      child.checked = checked
    })
  }

  toggleChild() {
    const allChecked = this.childTargets.every(child => child.checked)
    this.selectAllTarget.checked = allChecked
  }
}
